<template>
  <div class="nav">
    <CommonTabVue/>
    <div class="nav_user">
      <span style="componey" :title="companyName">所属公司：{{companyName}}</span>
      <!-- 消息 -->
      <el-popover placement="bottom" width="352" trigger="click" @show="showMess">
        <div class="drop_list">
          <el-tabs
            class="stock_tabs"
            v-model="activeName"
            @tab-click="handleClick"
            slot="dropdown"
          >
            <el-tab-pane label="消息中心" name="first">
            <!-- 库存预警 -->
              <ul class="warning_ul"  v-infinite-scroll="load">
                <li class="yj" v-for="(item,index) in inventoryWarning" :key="index">
                  <div class="li_txt">
                    <p class="p1" :title="item.minQuantityWarnInfo.warehouseName+'--'+item.minQuantityWarnInfo.skuName+'--'+item.minQuantityWarnInfo.modelNumber">{{item.minQuantityWarnInfo.warehouseName}}--{{item.minQuantityWarnInfo.skuName}}--({{item.minQuantityWarnInfo.modelNumber}})</p>
                    <p class="p2">{{item.noticeTime}}</p>
                  </div>
                  <div class="li_num">{{item.minQuantityWarnInfo.quantity}}个</div>
                </li>
              <!-- 订单通知 -->
                 <li class="notices" v-for="item in orderNotification" :key="item.id">
                  <p class="notice_p">
                    {{item.messageDesc}}
                  </p>
                  <p class="notice_time">{{item.noticeTime}}</p>
                </li>
              <!-- 暂无通知 -->
              <li class="no_notice" v-if="orderNotification.length==0&&inventoryWarning.length==0">暂无通知...</li>
              </ul>
              <!-- 售后服务 -->
              <!-- <ul class="afterSale_ul">
                <li>
                  <div class="li_img">
                    <img src="" alt="" />
                  </div>
                  <div class="li_txt">
                    <p class="title">
                      <span class="title_io">商品名称(规格型号)</span>
                      <span class="title_it">李明启</span>
                    </p>
                    <p class="txt">
                      门锁把手按下无法回位，锁舌不弹出，无法关门门锁把手按下无法回位，锁舌不弹出，无法关门
                    </p>
                    <p class="time">2022-7-12 16:33</p>
                  </div>
                </li>
              </ul> -->
            </el-tab-pane>
            <!-- <el-tab-pane :label="'售后服务(' + afterSale + ')'" name="second">
            </el-tab-pane>
            <el-tab-pane :label="'订单通知(' + orderNotification.length + ')'" name="three">
            </el-tab-pane> -->
          </el-tabs>
        </div>
        <el-badge :is-dot="isDot" class="item" slot="reference">
          <div class="bell_img">
            <img :src="bell" alt="" v-if="isDot" />
            <img :src="bell2" alt="" v-else />
          </div>
        </el-badge>
      </el-popover>
      <!-- 头像 -->
      <el-dropdown>
        <span class="el-dropdown-link">
          <img
            :src="'https://sso.chci.cn' + pic"
            alt=""
            style="width: 30px; height: 30px; border-radius: 50%"
          />
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>{{ userName }}</el-dropdown-item>
          <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { sysMessageList, checkToRead } from "./url.js";
import CommonTabVue from "./CommonTab.vue";
export default {
  name: "globalNav",
  data() {
    return {
      bell: require("@/assets/home/bell.gif"),
      bell2: require("@/assets/home/bell.png"),
      userName: $cookies.get("username") || "",
      SSOID: $cookies.get("SSOID") || "",
      pic: this.$store.state.userinfo.user.headpic,
      activeName: "first",
      // 预警信息
      warningNum: 0,
      // 售后服务
      afterSale: 0,
      // 订单通知
      notice: 0,
      isDot: false,
      timer: "", //定时器
      pageNum:1,
      pageSize:10,
      inventoryWarning:[],//库存预警
      afterSaleService:[],//售后服务
      orderNotification:[],//订单通知
      companyName:$cookies.get("companyName")
    };
  },
  components:{
    CommonTabVue
  },
  methods: {
    // 列表显示时触发
    showMess(){
      this.inventoryWarning=[],//库存预警
      this.afterSaleService=[],//售后服务
      this.orderNotification=[],//订单通知
      this.pageNum=1
      this.getMessList()
      this.isUnread()
    },
    // 瀑布流
    load(){
      this.pageNum+=1
      this.getMessList()
    },
    // 退出登录
    logout() {
      let that = this;
      //处理vueX
      that.$store.state.isLogin = false;
      that.$store.state.SSOID = "";
      that.$store.state.userinfo = {};
      that.$store.state.userName = "";
      that.$store.state.cookie = "";
      that.$store.commit("closeAllTab")
      that.$store.commit("loginOnce",false)
      this.$.ajax({
        //备用请求 和下面的vue-jsop实际效果是一样的  只不过这个是jq
        url: "https://sso.chci.cn/jsonLogout.do?SSOID="+ $cookies.get("SSOID"),
        type: "GET",
        dataType: "jsonp",
        jsonp: "mycallback",
        xhrFields: {
          withCredentials: true, //解决跨服务传递时不传递cookie的问题，允许携带证书
        },
        crossDomain: true, //允许跨域
        timeout: 5000,
        success: function (data) {
          that.$cookies
            .keys()
            .forEach((cookie) => that.$cookies.remove(cookie));
          that.$cookies.remove("SSOID", "/", ".chci.cn");
          that.$cookies.remove("JSESSIONID", "/", ".chci.cn");
          that.$cookies.remove("isLogin", "/", ".chci.cn");
          that.isLogin = false; //当前页登录状态改为 未登录
          let returnUrl = encodeURIComponent(window.location.href);
          window.location.href =
            "https://sso.chci.cn/login.do?method=get&returnURL=" + returnUrl;
        },
      });
    },
    handleClick() {},
    // 是否存在未读消息
    isUnread() {
      checkToRead().then((res) => {
        if (res.success) {
          this.isDot = res.result;
        } else {
          this.isDot = false;
        }
      });
    },
    // 获取消息列表
    getMessList() {
      console.log(this.pageNum);
      sysMessageList({ pageNum: this.pageNum, pageSize: 10 }).then((res) => {
        if(res.success){
          res.result.map((item)=>{
            if(item.messageType==0){
              this.orderNotification.push(item)
            }
            if(item.messageType==1){
              this.inventoryWarning.push(item)
            }
          })
        }
      });
    },
  },
  props: {
    // 公共面包屑
    breadcrumbList: {
      type: Array,
    },
  },
  mounted() {
    this.isUnread();
    if (this.timer) {
      clearInterval(this.timer);
    } else {
      let that = this;
      this.timer = setInterval(() => {
        that.isUnread();
      }, 10000);
    }
  },
  beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="scss" scoped>
.componey{
  font-size: 16px;
  font-weight: bold;
}
.no_notice{
  text-align: center;
}
::v-deep .el-tabs__nav-scroll{
  display: flex;
  justify-content: center;
}
.notice_ul::-webkit-scrollbar {
  width: 3px;
  height: 148px;
  background: #dce3f2;
}
.notice_ul {
  max-height: 390px;
  li {
    margin-bottom: 24px;
    .notice_p {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 22px;
      color: #222222;
      margin-bottom: 10px;
      white-space: wrap;
    }
    .notice_time {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 0px;
      color: #999999;
    }
  }
}
::v-deep .stock_tabs {
  padding-left: 14px;
}
.afterSale_ul::-webkit-scrollbar {
  width: 3px;
  height: 148px;
  background: #dce3f2;
}
.afterSale_ul {
  max-height: 390px;
  li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 62px;
    margin-bottom: 24px;
    .li_txt {
      width: calc(100% - 46px);
      height: 62px;
      .time {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 0px;
        color: #999999;
        width: 100%;
        margin-top: 12px;
      }
      .txt {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 18px;
        color: #999999;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        white-space: nowrap;
        margin-top: 6px;
      }
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        height: 15px;
        .title_io {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 0px;
          color: #222222;
        }
        .title_it {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 0px;
          color: #525252;
        }
      }
    }
    .li_img {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 14px;
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }
  }
}
.warning_ul::-webkit-scrollbar {
  width: 3px;
  height: 148px;
  background: #dce3f2;
}
.warning_ul {
  max-height: 390px;
  overflow: auto;
  .yj {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-bottom: 24px;
    .li_num {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 0px;
      color: #f83030;
    }
    .li_txt {
      width: 300px;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-around;
      .p1 {
        width: 280px;
        height: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 15px;
        color: #222222;
        // margin-bottom: 12px;
      }
      .p2 {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 0px;
        color: #999999;
        width: 250px;
        height: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        white-space: nowrap;
        line-height: 12px;
      }
    }
    .li_img {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 14px;
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }
  }
  .notices{
    margin-bottom: 24px;
    .notice_p {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 22px;
      color: #222222;
      margin-bottom: 10px;
      white-space: wrap;
    }
    .notice_time {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 0px;
      color: #999999;
    }
  }
}
::v-deep .drop_list {
  width: 100%;
  .el-tabs__item {
    width: 33.3%;
  }
}
::v-deep .isBlack {
  .el-breadcrumb__inner {
    color: #000;
  }
}
.el-dropdown-link {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-dropdown {
  margin-left: 26px;
  cursor: pointer;
}
.nav {
  width: calc(100% - 40px);
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background: #fff;
  flex-shrink: 0;
  .nav_user {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .bell_img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 50px;
        height: 30px;
      }
    }
  }
}
</style>